import { setLocale } from 'yup'

import { ERROR_MESSAGES } from '../../constants/constants'

class YupService {
  init() {
    this.setLocale()
  }

  setLocale() {
    setLocale({
      mixed: { required: ERROR_MESSAGES.required },
      string: { email: 'Please enter a valid email address' },
      number: {
        positive: 'Must be a positive number',
        min: ({ min }) => `Must be greater than or equal to ${min}`,
        max: ({ max }) => `Must be less than or equal to ${max}`,
      },
      array: { min: 'Please select at least one option' },
    })
  }
}

const yupService = new YupService()

export default yupService
